define(
    'MerchZone.View',
    [
        'CustomContentType.Base.View',
        'merchzone.tpl',
        'Utils',
        'jQuery',
        'underscore',
        'AddToCartModal.View',
        'Profile.Model'
    ],
    function (
        CustomContentTypeBaseView,
        template,
        Utils,
        jQuery,
        _,
        AddToCartModalView,
        ProfileModel
    ) {
        'use strict';

        return CustomContentTypeBaseView.extend({
            template: template,

            /**@type {Settings}*/
            settings: null,

            initialize: function (options) {
                this._initialize();
                this.environment = options.container.getComponent("Environment");
                this.configuration = this.environment.getConfig();
                this.layout = options.container.getComponent("Layout");
                this.cart = options.container.getComponent("Cart");
                this.addingToCart = false;
                this.trackingDataItems = [];
                this.dataTrackingName = "";

                /* MerchZone Setup */
                this.on('afterViewRender', function () {
                    var merchRule = this.settings.custrecord_ttmerchzone_merchrule;

                    // Get Data Tracking Name
                    this.dataTrackingName = this.settings.name || this.settings.custrecord_ttmerchzone_title || this.options.instanceId || "untracked name";

                    if (merchRule && merchRule !== '') {
                        this.fetchMerchZoneEndpoint(merchRule);
                    }
                });
            },

            install: function (settings, context_data) {
                this._install(settings, context_data);
                var promise = jQuery.Deferred();
                return promise.resolve();
            },

            events: {
                'click .tt-ext-merchzone-item-add-to-cart': 'addToCartEvent'
            },

            getItemData: function (internalid) {
                for (var i = 0; i < this.items.length; i++) {
                    if (this.items[i].id.toString() === internalid) {
                        return this.items[i];
                    }
                }
            },

            addToCartEvent: function (e) {
                var self = this;
                var internalid = e.currentTarget.getAttribute("data-id");

                if (self.addingToCart === false) {
                    self.addingToCart = true;

                    this.cart.addLine({
                        line: {
                            quantity: 1,
                            item: {
                                internalid: internalid
                            }
                        }
                    }).then(function () {
                        var modalView = new AddToCartModalView({
                            item: self.getItemData(internalid)
                        });

                        if (self.layout) {
                            self.layout.showContent(modalView,
                                {
                                    showInModal: true,
                                    options: {
                                        className: 'tt-ext-merchzone-modal'
                                    }
                                }
                            );

                            self.addingToCart = false;
                        }
                    });
                }
            },

            showPrice: function showPrice() {
                return this.settings.custrecord_ttmerchzone_price === "T" && !this.logInToSeePrice();
            },

            showSku: function showSku() {
                return this.settings.custrecord_ttmerchzone_sku === "T";
            },

            showRating: function getRating() {
                return this.settings.custrecord_ttmerchzone_reviews === "T";
            },

            showSeeMore: function showSeeMore() {
                /* The index of 'See More' button is 2 */
                return this.settings.custrecord_ttmerchzone_buttonaction === "2";
            },

            showAddToCart: function showAddToCart() {
                /* The index of 'Add To Cart' button is 1 */
                return (this.settings.custrecord_ttmerchzone_buttonaction === "1") && !this.logInToSeePrice();
            },

            getButtonStyle: function getButtonStyle() {
                var buttonStyle = "primary";

                switch (this.settings.custrecord_ttmerchzone_buttonstyle) {
                    case "1": buttonStyle = "primary"; break;
                    case "2": buttonStyle = "secondary"; break;
                    case "3": buttonStyle = "tertiary"; break;
                    case "4": buttonStyle = "quaternary"; break;
                    case "5": buttonStyle = "link"; break;
                }

                return buttonStyle;
            },

            showArrows: function showArrows() {
                /* Pager and Arrows:	1 */
                /* Only Arrows:			3 */
                /* Only Bottom Arrows:	4 */
                return this.settings.custrecord_ttmerchzone_controltype === "1" || this.settings.custrecord_ttmerchzone_controltype === "3" || this.settings.custrecord_ttmerchzone_controltype === "4";
            },

            showPager: function showPager() {
                /* Pager and Arrows:	1 */
                /* Only Pager:			2 */
                return this.settings.custrecord_ttmerchzone_controltype === "1" || this.settings.custrecord_ttmerchzone_controltype === "2";
            },

            getBorderType: function getBorderType() {
                /* None:	    1 */
                /* Item Cell:   2 */
                /* Item Image:  3 */
                switch (this.settings.custrecord_ttmerchzone_bordertype) {
                    case "2":
                        return "tt-ext-merchzone-border-cell";
                        break;
                    case "3":
                        return "tt-ext-merchzone-border-image";
                        break;
                    default:
                        return "";
                        break;
                }
            },

            /**
             * Log in to see price validation
             */
            logInToSeePrice: function logInToSeePrice() {
                var getRegistrationType = function () {
                    /* registrationmandatory is 'T' when customer registration is disabled */
                    if (this.environment.getSiteSetting('registration.registrationmandatory') === 'T') {
                        /* no login, no register, checkout as guest only */
                        return 'disabled';
                    }

                    else {
                        if (this.environment.getSiteSetting('registration.registrationoptional') === 'T') {
                            /* login, register, guest */
                            return 'optional';
                        }
                        else {
                            if (this.environment.getSiteSetting('registration.registrationallowed') === 'T') {
                                /* login, register, no guest */
                                return 'required';
                            }
                            else {
                                /* login, no register, no guest */
                                return 'existing';
                            }
                        }
                    }
                };

                /* We've got to disable loginToSeePrices feature if customer registration is disabled. */
                return getRegistrationType !== 'disabled' &&
                    this.environment.getSiteSetting('requireloginforpricing', 'F') === 'T' &&
                    ProfileModel.getInstance().attributes.isLoggedIn === 'F';
            },

            getDefaultImage: function getDefaultImage(itemimages) {
                /**
                 * Flatten method taken from SCA Utils
                 * @param {Object} images
                 * @returns {ItemImage[]}
                 */
                function flattenImages(images) {
                    if ('url' in images && 'altimagetext' in images) {
                        return [images];
                    }

                    return _.flatten(
                        _.map(images, function (item) {
                            if (_.isArray(item)) {
                                return item;
                            }
                            return flattenImages(item);
                        })
                    );
                };

                var imageData = flattenImages(itemimages);

                var defaultImage = _.find(imageData, function (image) {
                    var match = image.url.match(/.*\.default\.[A-Za-z]*/i);
                    return !!match && match[0] === image.url;
                });

                return defaultImage || imageData[0];
            },

            getControlsStyles: function getControlsStyles() {
                var controlsColor = this.settings.custrecord_ttmerchzone_controlscolor;

                switch (controlsColor) {
                    case "2": controlsColor = 'dark'; break;
                    case "3": controlsColor = 'light'; break;
                    default: controlsColor = 'default';
                }

                var classes = "tt-ext-merchzone-controls-style-" + controlsColor;
                classes += this.showArrows() ? " tt-ext-merchzone-controls-arrows" : "";
                classes += this.settings.custrecord_ttmerchzone_controlsshadow === "T" ? " tt-ext-merchzone-controls-style-shadows" : "";
                classes += this.settings.custrecord_ttmerchzone_controltype === "4" ? " tt-ext-merchzone-bottom-arrows" : "";

                return classes;
            },

            getItemsDevicesDisplay: function getItemsDevicesDisplay(itemsCount) {
                var xsCount = this.settings.custrecord_ttmerchzone_itemdisplayxs || "1";
                var smCount = this.settings.custrecord_ttmerchzone_itemdisplaysm || "2";
                var mdCount = this.settings.custrecord_ttmerchzone_itemdisplaymd || "3";
                var lgCount = this.settings.custrecord_ttmerchzone_itemdisplaylg || "4";
                var xlCount = this.settings.custrecord_ttmerchzone_itemdisplayxl || "4";

                var classes = "";

                classes += itemsCount < parseInt(xsCount) ? " tt-ext-merchzone-items-xs-" + itemsCount : " tt-ext-merchzone-items-xs-" + xsCount;
                classes += itemsCount < parseInt(smCount) ? " tt-ext-merchzone-items-sm-" + itemsCount : " tt-ext-merchzone-items-sm-" + smCount;
                classes += itemsCount < parseInt(mdCount) ? " tt-ext-merchzone-items-md-" + itemsCount : " tt-ext-merchzone-items-md-" + mdCount;
                classes += itemsCount < parseInt(lgCount) ? " tt-ext-merchzone-items-lg-" + itemsCount : " tt-ext-merchzone-items-lg-" + lgCount;
                classes += itemsCount < parseInt(xlCount) ? " tt-ext-merchzone-items-xl-" + itemsCount : " tt-ext-merchzone-items-xl-" + xlCount;

                classes += " tt-ext-merchzone-items-count-" + itemsCount;

                return classes;
            },

            getItemCellElements: function getItemCellElements() {
                var elements = [];

                for (var i = 0; i < this.configuration.tavanoTeam.smartmerchzone.productPricing.length; i++) {
                    if (this.configuration.tavanoTeam.smartmerchzone.productPricing[i].element === "Price") {
                        this.configuration.tavanoTeam.smartmerchzone.productPricing[i].price = true;
                    }

                    if (this.configuration.tavanoTeam.smartmerchzone.productPricing[i].element === "Old Price") {
                        this.configuration.tavanoTeam.smartmerchzone.productPricing[i].oldPrice = true;
                    }

                    if (this.configuration.tavanoTeam.smartmerchzone.productPricing[i].element === "Unit of Measure") {
                        this.configuration.tavanoTeam.smartmerchzone.productPricing[i].unitOfMeasure = true;
                    }

                    this.configuration.tavanoTeam.smartmerchzone.productPricing[i].initialLabel = Utils.translate(this.configuration.tavanoTeam.smartmerchzone.productPricing[i].initialLabel);
                    this.configuration.tavanoTeam.smartmerchzone.productPricing[i].endLabel = Utils.translate(this.configuration.tavanoTeam.smartmerchzone.productPricing[i].endLabel);
                }

                for (var i = 0; i < this.configuration.tavanoTeam.smartmerchzone.elements.length; i++) {
                    if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Image") {
                        elements.push({
                            image: true,
                            label: this.configuration.tavanoTeam.smartmerchzone.elements[i].label,
                            customField: this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId
                        });
                    }

                    if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Title") {
                        elements.push({
                            title: true,
                            label: this.configuration.tavanoTeam.smartmerchzone.elements[i].label,
                            customField: this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId
                        });
                    }

                    if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Sku") {
                        elements.push({
                            sku: this.showSku(),
                            label: this.configuration.tavanoTeam.smartmerchzone.elements[i].label,
                            customField: this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId
                        });
                    }

                    if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Price") {
                        elements.push({
                            price: this.showPrice(),
                            priceElements: this.configuration.tavanoTeam.smartmerchzone.productPricing,
                            label: this.configuration.tavanoTeam.smartmerchzone.elements[i].label
                        });
                    }

                    if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Rating") {
                        elements.push({
                            rating: this.showRating(),
                            label: this.configuration.tavanoTeam.smartmerchzone.elements[i].label
                        });
                    }

                    if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Action Buttons") {
                        elements.push({
                            actionButtons: true,
                            seeMoreButton: this.showSeeMore(),
                            logInToSeePrice: this.settings.custrecord_ttmerchzone_price === "T" && this.logInToSeePrice(),
                            addToCartButton: this.showAddToCart(),
                            label: this.configuration.tavanoTeam.smartmerchzone.elements[i].label
                        });
                    }

                    if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Custom") {
                        elements.push({
                            custom: true,
                            label: this.configuration.tavanoTeam.smartmerchzone.elements[i].label,
                            customField: this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId
                        });
                    }
                }

                return elements;
            },

            /**
             * Fetch merchzone information from SMT CMS endpoint
             * @param {string | number} merchzoneId Merchzone ID to fetch
             */
            fetchMerchZoneEndpoint: function fetchMerchZoneEndpoint(merchzoneId) {
                jQuery.ajax({
                    url: '/api/cms/v2/merchzones/' + merchzoneId,
                }).done(
                    function (res) {
                        this.fetchItems(res.data[0].queryString);
                    }.bind(this)
                ).fail(
                    function (err) {
                        console.error(err);
                    }
                );
            },

            formattedItemExtendFunction: function formattedItemExtendFunction(item, formattedItem) {
                return formattedItem;
            },

            /**
             * Fetch items from items enddpoint returned from merchzone endpoint
             * @param {string} itemsEndpoint
             */
            fetchItems: function fetchItems(itemsEndpoint) {
                jQuery.ajax({
                    url: itemsEndpoint,
                }).done(
                    function (res) {
                        var itemDetails = _.map(
                            res.items,
                            function (item) {
                                /** @type {Item} */
                                var isMatrix = item.matrixchilditems_detail ? item.matrixchilditems_detail.length > 0 : false;

                                /* old price */
                                var oldPrice = '';

                                if (this.configuration.priceLevel.enabled && !!this.configuration.priceLevel.default) {
                                    if (!!item[this.configuration.priceLevel.default + "_formatted"]) {
                                        if (item[this.configuration.priceLevel.default + "_formatted"] != item.onlinecustomerprice_formatted) {
                                            oldPrice = item[this.configuration.priceLevel.default + "_formatted"];
                                        }
                                    }
                                }

                                var customFields = [];
                                var customFieldIndex = 0;
                                for (var i = 0; i < this.configuration.tavanoTeam.smartmerchzone.elements.length; i++) {
                                    if (!!item[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId]) {
                                        customFields.push(item[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId]);
                                        this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex = customFieldIndex;
                                        customFieldIndex = customFieldIndex + 1;
                                    }
                                }

                                var formattedItem = {
                                    isinstock: item.isinstock,
                                    ispurchasable: item.ispurchasable,
                                    id: item.internalid, /* for 'Add To Cart' button */
                                    sku: item.itemid,
                                    isMatrix: isMatrix,
                                    name: item.storedisplayname || item.storedisplayname2 || item.displayname,
                                    price: {
                                        unformatted: item.onlinecustomerprice,
                                        formatted: item.onlinecustomerprice_formatted,
                                        matrix: !!item.onlinematrixpricerange ? item.onlinematrixpricerange : false,
                                        old: oldPrice,
                                        shopperCurrency: this.environment.getSiteSetting().shopperCurrency.code,
                                        unitstype: item.unitstype
                                    },
                                    rating: (this.showRating() && item.hasOwnProperty('custitem_ns_pr_rating')) ? ((item.custitem_ns_pr_rating >= 0 && item.custitem_ns_pr_rating <= 5) ? item.custitem_ns_pr_rating : 0) : 0,
                                    link: item.urlcomponent ? '/' + item.urlcomponent : '/product/' + item.internalid,
                                    image: this.getDefaultImage(item.itemimages_detail),
                                    customFields: customFields,
                                    nsBadges: (typeof item.custitem_ns_ib_badges === "undefined") ? [] : item.custitem_ns_ib_badges.split(", ")
                                };

                                formattedItem = this.formattedItemExtendFunction(item, formattedItem);

                                return formattedItem;

                            }.bind(this)
                        );

                        this.items = itemDetails;

                        this.renderMerchzone(itemDetails);

                    }.bind(this)
                );
            },

            /**
             * Render item info to template
             * @param {Item[]} items
             */
            renderMerchzone: function renderMerchzone(items) {
                if (items.length === 0) {
                    return;
                }

                _.each(
                    items,
                    function (item) {
                        // Save Item for Data Tracking
                        var itemTrackingData = {
                            item_id: item.id,
                            item_name: item.name,
                            price: item.price.formatted ? item.price.formatted : "untracked price",
                            currency: item.price.shopperCurrency
                        }

                        this.trackingDataItems.push(itemTrackingData);

                        // Create Item Event
                        if (typeof window.dataLayer !== "undefined") {
                            var trackingEvent = "window.dataLayer.push({" +
                                "event: 'TT_select_item'," +
                                "data: {" +
                                "item: {" +
                                "item_id: '" + itemTrackingData.item_id + "'," +
                                "item_name: '" + itemTrackingData.item_name + "'," +
                                "price: '" + itemTrackingData.price + "'," +
                                "currency: '" + itemTrackingData.currency + "'" +
                                "}," +
                                "item_list_id: 'merchzone'," +
                                "item_list_name: '" + this.dataTrackingName + "'," +
                                "currency: '" + this.environment.getSiteSetting().shopperCurrency.code + "'" +
                                "}" +
                                "});";
                        }

                        // Create Item Template
                        /* Clone Template */
                        var template = this.$('#tt-ext-merchzone-item-template').contents().clone();

                        // Add Tracking Event to Item links and buttons
                        template.find('.tt-ext-merchzone-item a > span').attr('onclick', trackingEvent);
                        template.find('.tt-ext-merchzone-item a > img').attr('onclick', trackingEvent);
                        template.find('.tt-ext-merchzone-item button').attr('onclick', trackingEvent);

                        for (var i = 0; i < this.configuration.tavanoTeam.smartmerchzone.elements.length; i++) {
                            /* IMAGES */
                            if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Image") {
                                /* Images: No Image Available checker */
                                if (typeof item.image === "undefined") {
                                    item.image = {
                                        url: Utils.getThemeAbsoluteUrlOfNonManagedResources('img/no_image_available.jpeg', this.configuration.imageNotAvailable),
                                        altimagetext: item.name
                                    };
                                }

                                /* Images: Resize Image */
                                item.image.url = Utils.resizeImage(this.configuration.siteSettings.imagesizes || [], item.image.url, this.configuration.tavanoTeam.smartmerchzone.image.sizeId);

                                var custImgUrl = "";
                                if (item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex]) {
                                    custImgUrl = Utils.resizeImage(this.configuration.siteSettings.imagesizes || [], item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex], this.configuration.tavanoTeam.smartmerchzone.image.sizeId);
                                }

                                /* Images: Lazy Loading checker */
                                if (typeof lazySizes != 'undefined') {
                                    if (!!custImgUrl) {
                                        template.find('[data-tt-ext-merchzone="' + this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId + '"]').attr('data-src', custImgUrl);
                                        template.find('[data-tt-ext-merchzone="' + this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId + '"]').addClass('lazyload');
                                    } else {
                                        template.find('[data-tt-ext-merchzone="image"]').attr('data-src', item.image.url);
                                        template.find('[data-tt-ext-merchzone="image"]').addClass('lazyload');
                                    }
                                } else {
                                    if (!!custImgUrl) {
                                        template.find('[data-tt-ext-merchzone="' + this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId + '"]').attr('src', custImgUrl);
                                    } else {
                                        template.find('[data-tt-ext-merchzone="image"]').attr('src', item.image.url);
                                    }
                                }

                                template.find('[data-tt-ext-merchzone="image"]').attr('alt', (item.image.altimagetext || item.name));
                            }

                            /* TITLE */
                            if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Title") {
                                if (item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex]) {
                                    template.find('[data-tt-ext-merchzone="' + this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId + '"]').text(item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex]);
                                } else {
                                    template.find('[data-tt-ext-merchzone="name"]').text(item.name);
                                }
                            }

                            /* SKU */
                            if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Sku") {
                                if (this.showSku()) {
                                    if (item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex]) {
                                        template.find('[data-tt-ext-merchzone="' + this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId + '"]').text(item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex]);
                                    } else {
                                        if (!!item.sku) {
                                            template.find('[data-tt-ext-merchzone="sku-value"]').text(item.sku);
                                        } else {
                                            template.find('[data-tt-ext-merchzone="sku"]').remove();
                                        }
                                    }
                                }
                            }

                            /* CUSTOM */
                            if (this.configuration.tavanoTeam.smartmerchzone.elements[i].element === "Custom") {
                                if (item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex]) {
                                    template.find('[data-tt-ext-merchzone="' + this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId + '"]').text(item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex]);
                                    template.find('[data-tt-ext-merchzone="' + this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldId + '"]').attr('data-tt-ext-merchzone-value', item.customFields[this.configuration.tavanoTeam.smartmerchzone.elements[i].customFieldIndex]);
                                } else {
                                    template.find('.tt-ext-merchzone-item-custom-label').remove();
                                    template.find('.tt-ext-merchzone-item-custom').remove();
                                }
                            }
                        }

                        // NS Badges
                        item.nsBadges.forEach(function (nsBadge) {
                            template.find('[data-tt-ext-merchzone-badge="' + nsBadge + '"]').addClass("tt-ext-merchzone-item-nsbadges-badge-active");
                        });

                        template.find('[data-tt-ext-merchzone-badge]:not(.tt-ext-merchzone-item-nsbadges-badge-active)').remove();

                        /* Links */
                        template.find('[data-tt-ext-merchzone="link"]').attr('href', item.link);

                        /* Price */
                        if (this.showPrice() && !!item.price && item.ispurchasable) { /* 'item.isinstock' is not necessary for the moment */
                            /* Matrix Price */
                            if (!!item.price.matrix) {
                                var matrixPrices = item.price.matrix.split(' ');

                                if (matrixPrices[0] != matrixPrices[1]) {
                                    template.find('[itemprop="lowPrice"]').text(Utils.formatCurrency(matrixPrices[0]));
                                    template.find('[itemprop="lowPrice"]').attr('data-rate', matrixPrices[0]);
                                    template.find('[itemprop="highPrice"]').text(Utils.formatCurrency(matrixPrices[1]));
                                    template.find('[itemprop="highPrice"]').attr('data-rate', matrixPrices[1]);

                                    /* Remove Lead Price */
                                    template.find('.product-views-price-lead').remove();
                                } else {
                                    /* Low and High Prices are equal, set lead price instead */
                                    item.price.matrix = false;
                                }
                            }

                            /* Lead Price */
                            if (!!item.price.matrix === false) {
                                template.find('[data-tt-ext-merchzone="price-lead"]').text(item.price.formatted);
                                template.find('[data-tt-ext-merchzone="price-lead"]').attr('data-rate', item.price.unformatted);

                                /* Remove Range Price */
                                template.find('[data-tt-ext-merchzone="price-range"]').remove();
                            }

                            /* Old Price */
                            if (!!item.price.old && (item.price.formatted != item.price.old)) {
                                template.find('[data-tt-ext-merchzone="price-old"]').text(item.price.old);
                            } else {
                                /* Remove Old Price */
                                template.find('.product-views-price-old').remove();
                            }

                            /* Unit Price */
                            if (item.price.unitstype) {
                                template.find('[data-tt-ext-merchzone="unitstype"]').text(item.price.unitstype);
                            } else {
                                template.find('.tt-product-views-price-unitstype').remove();
                            }

                            /* Price availability for 'schema.org' */
                            var availability = 'https://schema.org/OutOfStock';

                            if (item.ispurchasable) {
                                if (item.isinstock) {
                                    availability = 'https://schema.org/InStock';
                                } else {
                                    if (this.configuration.structureddatamarkup.availabilityonbackorder === 'PreOrder') {
                                        availability = 'https://schema.org/PreOrder';
                                    } else {
                                        availability = 'https://schema.org/InStock';
                                    }
                                }
                            }

                            template.find('[itemprop="availability"]').attr('href', availability);

                            /* Set the price meta content */
                            template.find('meta[itemprop="priceCurrency"]').attr('content', item.price.shopperCurrency);
                        } else {
                            /* Remove Price */
                            template.find('[data-tt-ext-merchzone="price"]').remove();
                        }

                        /* Rating */
                        if (this.showRating()) {
                            template.find('[data-tt-ext-merchzone="rating-fill"]').attr('style', 'width:' + ((parseFloat(item.rating) * 100) / 5) + '%;');
                            template.find('[data-tt-ext-merchzone="rating"] [data-value]').attr('data-value', item.rating);
                            template.find('[data-tt-ext-merchzone="rating"] [itemprop="ratingValue"]').attr('content', item.rating);
                        }

                        /* 'Add To Cart' & 'Choose Options' Buttons */
                        if (this.showAddToCart() && item.ispurchasable) { /* 'item.isinstock' is not necessary for the moment */
                            if (!item.isMatrix) {
                                /* 'Add To Cart' Button */
                                template.find('[data-tt-ext-merchzone="add-to-cart"]').attr('data-id', item.id);
                                template.find('[data-tt-ext-merchzone="add-to-cart"]').addClass('button-' + this.getButtonStyle());

                                /* Remove 'Choose Options' Button */
                                template.find('[data-tt-ext-merchzone="choose-options"]').remove();
                            } else {
                                /* 'Choose Options' Button */
                                template.find('[data-tt-ext-merchzone="choose-options"]').attr('href', item.link);
                                template.find('[data-tt-ext-merchzone="choose-options"]').addClass('button-' + this.getButtonStyle());

                                /* Remove 'Add To Cart' Button */
                                template.find('[data-tt-ext-merchzone="add-to-cart"]').remove();
                            }
                        } else {
                            /* Remove 'Add To Cart' & 'Choose Options' Buttons */
                            template.find('[data-tt-ext-merchzone="add-to-cart"]').remove();
                            template.find('[data-tt-ext-merchzone="choose-options"]').remove();
                        }

                        /* 'See More' Button */
                        if (this.showSeeMore()) {
                            template.find('[data-tt-ext-merchzone="see-more"]').attr('href', item.link);
                            template.find('[data-tt-ext-merchzone="see-more"]').addClass('button-' + this.getButtonStyle());
                        } else {
                            /* Remove 'See More' button */
                            template.find('[data-tt-ext-merchzone="see-more"]').remove();
                        }

                        /* Add Template */
                        this.$('.tt-ext-merchzone-items-wrapper').append(template);
                    },
                    this
                );

                /* Items To Display */
                this.$('.tt-ext-merchzone-items-container').addClass(this.getItemsDevicesDisplay(items.length));

                /* Render Carousel */
                if (this.settings.custrecord_ttmerchzone_iscarousel === 'T') {
                    this.renderCarousel();
                }

                // Trigger initial Data Tracking Event
                if (typeof window.dataLayer !== "undefined") {
                    window.dataLayer && window.dataLayer.push({
                        event: 'TT_view_item_list',
                        data: {
                            items: this.trackingDataItems,
                            item_list_id: 'merchzone',
                            item_list_name: this.dataTrackingName,
                            currency: this.environment.getSiteSetting().shopperCurrency.code
                        }
                    });
                }
            },

            renderCarousel: function renderCarousel() {
                var carouselOptions = {
                    auto: this.settings.custrecord_ttmerchzone_autoslide && this.settings.custrecord_ttmerchzone_autoslide === "T",
                    pause: parseInt(this.settings.custrecord_ttmerchzone_autoslidetime || 5000),
                    infiniteLoop: this.settings.custrecord_ttmerchzone_infiniteloop === "T",
                    hideControlOnEnd: this.settings.custrecord_ttmerchzone_infiniteloop != "T",
                    randomStart: this.settings.custrecord_ttmerchzone_randomstart === "T",
                    adaptiveHeight: true,
                    minSlides: 1,
                    maxSlides: parseInt(this.settings.custrecord_ttmerchzone_itemdisplayxl || 4),
                    slideWidth: 300,
                    touchEnabled: true,
                    swipeThreshold: 100,
                    oneToOneTouch: true,
                    preventDefaultSwipeX: true,
                    preventDefaultSwipeY: false,
                    stopAutoOnClick: true,
                    autoHover: true,
                    moveSlides: this.settings.custrecord_ttmerchzone_moveone === "T" ? 1 : 0,
                    pager: this.showPager(),
                    controls: this.showArrows(),
                    nextText: '<a class="tt-ext-merchzone-next-icon"></a>',
                    prevText: '<a class="tt-ext-merchzone-prev-icon"></a>'
                };

                Utils.initBxSlider(this.$('.tt-ext-merchzone-items-wrapper'), carouselOptions);
            },

            contextDataRequest: [],

            validateContextDataRequest: function validateContextDataRequest() {
                return true;
            },

            getBadgesPosition: function getBadgesPosition() {
                if (typeof this.configuration.itemBadges === 'undefined') {
                    return '';
                } else if (typeof this.configuration.itemBadges.position != 'undefined') {
                    return this.configuration.itemBadges.position;
                } else {
                    return '';
                }
            },

            getContext: function () {
                return {
                    container: this.settings.custrecord_ttmerchzone_contentcontainer === "T" ? "container" : "container-fluid",
                    title: this.settings.custrecord_ttmerchzone_title,
                    grid: {
                        enable: this.settings.custrecord_ttmerchzone_iscarousel != "T",
                        classes: (this.settings.custrecord_ttmerchzone_gridcenter === "T" ? " tt-ext-merchzone-center-items" : "")
                    },
                    carousel: {
                        enable: this.settings.custrecord_ttmerchzone_iscarousel === "T",
                        classes: this.getControlsStyles()
                    },
                    elements: this.getItemCellElements(),
                    borderType: this.getBorderType(),
                    nsBadges: {
                        badges: this.configuration.tavanoTeam.smartmerchzone.nsBadges.length > 1 ? this.configuration.tavanoTeam.smartmerchzone.nsBadges : [],
                        position: this.getBadgesPosition()
                    }
                };
            }
        });
    });
